module.exports = new __parcel__URL__("neon_gold_accelerator_level_1.7d4753f7.png").toString();